/**
 * Reticles Display JavaScript
 * 处理图片详情弹窗功能
 */

class ReticlesDisplay {
  constructor() {
    this.init();
  }

  init() {
    // 等待 DOM 完全加载
    this.setupDetailButtons();
    this.setupModalCloseButtons();
    this.setupEscapeKey();
  }

  setupDetailButtons() {
    const detailButtons = document.querySelectorAll('[data-reticle-detail]');
    
    detailButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const imagePc = button.getAttribute('data-image-pc');
        const imageMobile = button.getAttribute('data-image-mobile');
        const imageAlt = button.getAttribute('data-image-alt') || '';
        
        this.openModal(imagePc, imageMobile, imageAlt);
      });
    });
  }

  setupModalCloseButtons() {
    const closeButtons = document.querySelectorAll('[data-reticle-close]');
    
    closeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeModal();
      });
    });
  }

  setupEscapeKey() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeModal();
      }
    });
  }

  openModal(imagePcSrc, imageMobileSrc, imageAlt) {
    if (!imagePcSrc && !imageMobileSrc) {
      console.warn('No image source provided');
      return;
    }

    // 查找所有模态框（可能有多个 section）
    const modals = document.querySelectorAll('.reticles-modal');
    
    modals.forEach(modal => {
      const modalImagePc = modal.querySelector('[data-modal-image-pc]');
      const modalImageMobile = modal.querySelector('[data-modal-image-mobile]');
      const modalContent = modal.querySelector('.reticles-modal__content');
      
      if (modalImagePc && modalImageMobile && modalContent) {
        // 显示 loading 状态
        modalContent.classList.add('is-loading');
        
        // 显示模态框
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        
        // 预加载图片
        let loadedCount = 0;
        const totalImages = 2;
        const startTime = Date.now();
        const minLoadingTime = 300; // 最小加载时间300ms，避免闪烁
        
        const checkAllLoaded = () => {
          loadedCount++;
          if (loadedCount === totalImages) {
            // 计算已经过去的时间
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, minLoadingTime - elapsedTime);
            
            // 确保至少显示最小加载时间，避免闪烁
            setTimeout(() => {
              modalContent.classList.remove('is-loading');
            }, remainingTime);
          }
        };
        
        // 加载 PC 端图片
        if (imagePcSrc) {
          const imgPc = new Image();
          imgPc.onload = () => {
            modalImagePc.src = imagePcSrc;
            modalImagePc.alt = imageAlt;
            checkAllLoaded();
          };
          imgPc.onerror = () => {
            console.error('Failed to load PC image');
            checkAllLoaded();
          };
          imgPc.src = imagePcSrc;
        } else {
          checkAllLoaded();
        }
        
        // 加载移动端图片
        if (imageMobileSrc) {
          const imgMobile = new Image();
          imgMobile.onload = () => {
            modalImageMobile.src = imageMobileSrc;
            modalImageMobile.alt = imageAlt;
            checkAllLoaded();
          };
          imgMobile.onerror = () => {
            console.error('Failed to load mobile image');
            checkAllLoaded();
          };
          imgMobile.src = imageMobileSrc;
        } else {
          checkAllLoaded();
        }
        
        // 聚焦到关闭按钮
        const closeButton = modal.querySelector('.reticles-modal__close');
        if (closeButton) {
          setTimeout(() => closeButton.focus(), 100);
        }
      }
    });
  }

  closeModal() {
    const modals = document.querySelectorAll('.reticles-modal');
    
    modals.forEach(modal => {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      
      // 移除 loading 状态
      const modalContent = modal.querySelector('.reticles-modal__content');
      if (modalContent) {
        modalContent.classList.remove('is-loading');
      }
      
      // 清空图片源以节省内存
      const modalImagePc = modal.querySelector('[data-modal-image-pc]');
      const modalImageMobile = modal.querySelector('[data-modal-image-mobile]');
      
      if (modalImagePc) {
        modalImagePc.src = '';
      }
      if (modalImageMobile) {
        modalImageMobile.src = '';
      }
    });
  }
}

// 初始化函数
function initReticlesDisplay() {
  new ReticlesDisplay();
}

// 确保 DOM 加载完成后初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReticlesDisplay);
} else {
  initReticlesDisplay();
}

// 支持主题编辑器实时预览
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initReticlesDisplay);
  document.addEventListener('shopify:section:reorder', initReticlesDisplay);
}
